<template>
	<div :class="[marginTop ? 'mt-4': '']">
		<div
			v-if="$slots.default"
			class="mb-2 text-sm font-semibold text-gray-800"
		>
			<slot />

			<div
				v-if="$slots?.subtitle"
				class="won-color-subtitle-gray mt-0.5 text-sm font-normal"
			>
				<slot name="subtitle" />
			</div>
		</div>

		<div
			v-if="!showValue"
			:class="inputWrapperClasses"
			class="relative flex items-center"
		>
			<input
				:id="idKey"
				:data-cy="dataCy"
				:value="modelValue"
				:placeholder="placeholder"
				:autocomplete="autocomplete"
				:type="type"
				:readonly="readonly"
				:required="required"
				:maxlength="maxlength"
				:disabled="disabled"
				:class="[
					inputStyle,
					classList,
					{
						'border-red-400': errors,
						'border-gray-300': !errors,
					},
					disabled && 'opacity-50'
				]"
				@input="(e) => handleChange(e.target.value)"
				@blur="$emit('input:blur')"
			/>
            
			<div
				v-if="slots?.inputIcon != null"
				class="absolute right-3"
			>
				<slot name="inputIcon" />
			</div>
		</div>


		<div
			v-else
			:class="['won-label-text-color text-sm', limitPreviewLength && 'text-overflow-ellipsis' ]"
		>
			{{ modelValue || "-" }}
		</div>

		<div
			v-if="showErrors"
			class="mt-2"
		>
			<p
				v-for="error in errors"
				:key="error"
				class="flex items-center space-x-2"
			>
				<span class="size-4"><svg
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				> <path
					d="M7.00016 0.333008C3.32016 0.333008 0.333496 3.31967 0.333496 6.99967C0.333496 10.6797 3.32016 13.6663 7.00016 13.6663C10.6802 13.6663 13.6668 10.6797 13.6668 6.99967C13.6668 3.31967 10.6802 0.333008 7.00016 0.333008ZM7.66683 10.333H6.3335V8.99967H7.66683V10.333ZM7.66683 7.66634H6.3335V3.66634H7.66683V7.66634Z"
					fill="#FF5F5F"
				/> </svg></span>
				<span class="text-sm text-red-500">{{ error }}</span>
			</p>
		</div>
	</div>
</template>

<script>
import { onMounted, useSlots } from 'vue';

import { inputStyle } from '../../utils/styles';

export default {
	props: {
		idKey: String,
		type: {
			type: String,
			default: 'text',
		},
		placeholder: String,
		modelValue: [String, Number],
		readonly: {
			type: Boolean,
			default: false,
		},
		autocomplete: {
			type: [Boolean, String],
			default: true,
		},
		required: {
			type: Boolean,
			default: false,
		},
		maxlength: {
			type: Number,
			default: 100,
		},
		classList: {
			type: String,
			default: '',
		},
		errors: {
			type: Array,
			default: null,
		},
		showValue: {
			type: Boolean,
			default: false,
		},
		showErrors: {
			type: Boolean,
			default: true,
		},
		storageKey: {
			type: String,
			default: undefined,
		},
		marginTop: {
			type: Boolean,
			default: true
		},
		limitPreviewLength: {
			type: Boolean,
			default: false
		},
		inputWrapperClasses: {
			type: String,
			default: ''
		},
		dataCy: {
			type: String,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	setup({ storageKey, modelValue }, { emit }) {
		const slots = useSlots();

		onMounted(() => {
			if (storageKey && !modelValue) {
				const fullKey = `WONSULTING-${storageKey}`;
				const value = localStorage.getItem(fullKey);

				if (value) {
					emit('update:modelValue', value);
				}
			}
		});

		return {
			inputStyle,
			slots
		};
	},

	methods: {
		handleChange(value) {
			this.$emit('update:modelValue', value);

			if (this.storageKey) {
				const fullKey = `WONSULTING-${this.storageKey}`;
				localStorage.setItem(fullKey, value);
			}
		},
	},
};
</script>
